import { render } from "./IoTEdge.vue?vue&type=template&id=c5717310&scoped=true"
import script from "./IoTEdge.vue?vue&type=script&lang=js"
export * from "./IoTEdge.vue?vue&type=script&lang=js"

import "./IoTEdge.vue?vue&type=style&index=0&id=c5717310&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5717310"]])

export default __exports__